import { Arrow } from "frontend/ui-components/svg-shapes";
import { CanvasTemplateMinimal } from "shared/datamodel/schemas/canvas-template";
import TemplatePreview from "./template-preview";
import style from "../../templates-modal.module.css";
import templatePreviewStyle from "./template-preview.module.css";

interface TemplatePreviewViewProps {
  template: CanvasTemplateMinimal;
  onClosePreview: () => void;
  onChooseTemplate: (template: CanvasTemplateMinimal) => void;
  onUpgradeModalShown: () => void;
  onDismiss: () => void;
}

export function TemplatePreviewView({
  template,
  onClosePreview,
  onChooseTemplate,
  onUpgradeModalShown,
  onDismiss,
}: TemplatePreviewViewProps) {
  return (
    <div className={style.previewContainer}>
      <div className={templatePreviewStyle.closePreview} onClick={onClosePreview}>
        <Arrow direction="left" stroke={"#113357"} scale={0.8} />
        <span>Back to templates</span>
      </div>
      <TemplatePreview
        template={template}
        onChooseTemplate={onChooseTemplate}
        onUpgradeModalShown={onUpgradeModalShown}
        onDismiss={onDismiss}
      />
    </div>
  );
}
